import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/labels'),
      name: 'labels_wrapper',
      meta: {
        permissions: ['administrator'],
      },
      redirect: to => {
        return { name: 'labels_list', params: to.params };
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/labels/list'),
      name: 'labels_list',
      meta: {
        featureFlag: FEATURE_FLAGS.LABELS,
        permissions: ['administrator'],
      },
      component: Index,
    },
  ],
};
